import React, { useState, useEffect } from "react";
import { NavDropdown } from "react-bootstrap";
import { Link, graphql, useStaticQuery } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import styled from "styled-components";
import { FaAngleDown, FaTimes } from "react-icons/fa";

const query = graphql`
	{
		allFile(filter: { relativeDirectory: { eq: "icon" }, ext: { ne: "svg" } }) {
			nodes {
				name
				childImageSharp {
					gatsbyImageData(placeholder: BLURRED, height: 20, width: 20)
				}
			}
		}
	}
`;

const Elementos = ({ arreglo, nodes }) => {
	return arreglo.map((item, index) => {
		const pathToImage = getImage(nodes[item.icon - 1]);
		return (
			<NavDropdown.Item as='li' key={index}>
				<Link
					to={item?.link}
					className='dropdown-item'
					activeClassName='active'>
					<GatsbyImage image={pathToImage} alt={item.alt} />
					&nbsp;&nbsp;&nbsp;
					<span>{item.title}</span>
				</Link>
			</NavDropdown.Item>
		);
	});
};

const Sub = ({ title, arreglo, nodes }) => {
	return (
		<div className='dropdown-sub'>
			<h6>{title}</h6>
			<Elementos arreglo={arreglo} nodes={nodes} />
		</div>
	);
};
const SelectedPages = ["person", "company"];

const DropPersonas = () => {
	const data = useStaticQuery(query);
	const nodes = data.allFile.nodes;
	const [isShow, setIsShow] = useState(false);

	const NavDropdownTitle = (
		<span>
			Productos <FaAngleDown />
		</span>
	);

	useEffect(() => {
		if (isShow) {
			setTimeout(() => setIsShow(false), 3000);
		}
	}, [isShow]);

	useEffect(() => {
		if (
			window.location.pathname === "/" ||
			window.location.pathname === "/company"
		) {
			setIsShow(true);
		}
	}, []);
	return (
		<Wrapper
			title={NavDropdownTitle}
			renderMenuOnMount={true}
			show={isShow}
			onToggle={() => setIsShow(!isShow)}
			id='prod-dropdown'>
			<span
				className='close-icon'
				onClick={() => {
					setIsShow(false);
				}}>
				<FaTimes />
			</span>
			<div className='row'>
				<div className='col-sm-12 col-md-6 col-lg-6'>
					<Sub title='Personas' arreglo={prodPersonas} nodes={nodes} />
				</div>
				<div className='col-sm-12 col-md-6 col-lg-6'>
					<Sub title='Empresas' arreglo={prodEmpresas} nodes={nodes} />
				</div>
			</div>
		</Wrapper>
	);
};

export default DropPersonas;

const Wrapper = styled(NavDropdown)`
	position: relative;
	.close-icon {
		position: absolute;
		right: 30px;
		font-size: 15px;
		font-weight: 900;
		color: #3cdbc0;
		cursor: pointer;
		z-index: 20;
		transition: all 0.5s;
		&:hover {
			font-size: 16px;
		}
	}
	.show {
		left: -210px;
		margin-top: 33px !important;
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		width: 620px;
		@media (max-width: 991px) {
			flex-direction: column;
		}
	}
	.dropdown-sub {
		@media screen and (max-width: 600px) {
			width: 50%;
			margin: 0 auto;
			text-align: left;
		}
	}
	.dropdown-item {
		.dropdown-item:hover span,
		.dropdown-item.active span {
			color: #1a2a6a;
			border-bottom: 1px solid #1a2a6a;
		}
		span {
			font-weight: 500;
			font-size: 14px;
			padding-bottom: 5px;
			color: gray;
			border-bottom: 1px solid transparent;
			transition: all 0.5s;
		}
		img {
			width: 100%;
			margin-right: 10px;
		}
	}
`;
const prodPersonas = [
	{
		link: "/automovil",
		alt: "Automovil",
		title: "Automóvil",
		icon: 1,
	},
	{
		link: "/accident",
		alt: "Accidentes",
		title: "Accidentes personales",
		icon: 4,
	},

	{
		link: "/hogar",
		alt: "hogar",
		title: "Seguro de Hogar",
		icon: 5,
	},
	{
		link: "/vida",
		alt: "vida",
		title: "Vida",
		icon: 6,
	},
	{
		link: "/medical-expense",
		alt: "Gastos médicos",
		title: "Gastos médicos",
		icon: 2,
	},
];

const prodEmpresas = [
	{
		link: "/company/automovil",
		alt: "Auto/Flotilla",
		title: "Auto/Flotilla",
		icon: 1,
	},
	{
		link: "/company/tractocamiones",
		alt: "Tractocamiones",
		title: "Tractocamiones",
		icon: 3,
	},
	{
		link: "/company/accident",
		alt: "Accidentes",
		title: "Accidentes personales",
		icon: 4,
	},

	{
		link: "/company/vida-grupo",
		alt: "Vida grupo",
		title: "Vida grupo",
		icon: 6,
	},
	{
		link: "/company/medical-expense-group",
		alt: "Gastos médicos grupal",
		title: "Gastos médicos grupal",
		icon: 2,
	},
	{
		link: "/company/empresarial",
		alt: "Empresarial",
		title: "Seguro empresarial",
		icon: 9,
	},
];
